import React, { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';

// import required modules
import { EffectCoverflow, Pagination } from 'swiper/modules';

import './projects.css';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
const projects = [{ p_id: "", p_link: "https://asvmall.com/", p_can_redirect: 1, p_added_on: "2024-12-21 16:47:45", p_title: "ASV Mall", p_image: "assets/img/projects/project1.png" },
{ p_id: "", p_link: "", p_can_redirect: 1, p_added_on: "2024-12-21 16:47:45", p_title: "DogSpot", p_image: "assets/img/projects/project2.png" },
{ p_id: "", p_link: "", p_can_redirect: 1, p_added_on: "2024-12-21 16:47:45", p_title: "Gantasoft CRM tool", p_image: "assets/img/projects/project3.png" }
]

const statusCode = {"SUCCESS":"SUCCESS",FAILED:"FAILED","EMPTY":"EMPTY"}
export default function Projects() {
  const [projectsList, setProjectsList] = useState([])
  const [status, setStatus] = useState("LOADING")
const navigate = useNavigate();

const onProjectClick=(eachProject)=>{
  if(eachProject.p_can_redirect == "1"){
    window.open(eachProject.p_link, "_blank");
  }else{
    alert("link updated")
  }
  
}
  useEffect(() => {

    axios.post("https://gantasoft.com//gantasoft/getprojects.php",
      { "main_id": "8989877hhftgh67" }).then(
        res => {
          if (Array.isArray(res.data) && res.data.length>0 ) {
            setProjectsList(res.data)
            setStatus(statusCode.SUCCESS)
          }else{
            setStatus(statusCode.EMPTY)
          }
        }

      ).catch(e => {
        console.log(e)
        setStatus(statusCode.FAILED)
      })

  }, [])

  const getProjectsUi = ()=>{
    switch(status){
      case statusCode.SUCCESS:

      return   <div className="row gy-5">

         

      <Swiper
        effect={'coverflow'}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={'auto'}
        loop={true}
        coverflowEffect={{
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        }}
        pagination={true}s
        modules={[EffectCoverflow, Pagination]}
        className="mySwiper"
      >{
        projectsList.map(eachProject => (
            <SwiperSlide >
              <Link  to={`/projects?prjid=${eachProject.p_id}`}>
              <img src={eachProject.p_image}  alt={eachProject.p_title}/>
              <h5>{eachProject.p_title}</h5>
              </Link>
            </SwiperSlide>
          ))
        }
      </Swiper>
    </div>;

      case statusCode.FAILED:
      return  <div className="row gy-5 d-flex justify-content-center">
        <img  src="assets/img/errorIMG.png"  className="error-img" alt="error loading Resources"/>
      </div>;
      default:

      return <div className="row gy-5 d-flex justify-content-center">
      <img  src="assets/img/errorIMG.png"  className="error-img" alt="error loading Resources"/>
    </div>;
    }
  }
  return (
    <section id="projects" className="projects section">
      {/* Section Title */}
      <div className="container section-title" data-aos="fade-up">
        <h2>Some of Our Completed Projects</h2>
        <p>We provide a complete range of high-quality web design and development services. Our affordable, custom web design solutions are specifically crafted to meet your unique needs. Choose from our top-tier plans to create a responsive website that perfectly aligns with your business goals..</p>
      </div>

      <div className="container" data-aos="fade-up" data-aos-delay="100">
        {getProjectsUi()}
      
      </div>

    </section>

  );
}
